import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../mutations/MutationTypes';
import {
	CreateBaselineVersionPhaseInput,
	CreateBaselineVersionPhaseMutation,
} from './__generated__/CreateBaselineVersionPhaseMutation.graphql';

const mutation = graphql`
	mutation CreateBaselineVersionPhaseMutation($input: CreateBaselineVersionPhaseInput!) {
		createBaselineVersionPhase(input: $input) {
			project {
				id
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<CreateBaselineVersionPhaseInput>,
	onSuccess?: RelayOnCompleted<CreateBaselineVersionPhaseMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<CreateBaselineVersionPhaseMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
